var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"top-header"}},[_c('div',{staticClass:"center-title"},[_vm._v(" 朵云产业链系统 ")])])
}]

export { render, staticRenderFns }